import { Box, HStack, Header, Text } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { theme } from 'styles/configure-theme';

const MENU_TILE_GRID_GAP = 24;
export const MENU_TILE_GRID_HALF_GAP = MENU_TILE_GRID_GAP / 2;

const MENU_IMAGE_MOBILE_WIDTH = 104;
const MENU_IMAGE_DESKTOP_WIDTH = 248;

export const PriceAndCaloriesListWrapper = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'flex-start',
  space: '$2',
});

export const Tile = HStack.withConfig(() => ({
  flexShrink: 1,
  flexGrow: 1,
  height: '112px',
  alignItems: 'center',
  paddingX: '$4',
  paddingY: '$2',
  _web: {
    cursor: 'pointer',
  },
  minHeight: {
    md: '320px',
  },
}));

export const TileCard = Box.withConfig({
  margin: `${MENU_TILE_GRID_HALF_GAP}px`,
  _web: {
    maxWidth: `calc(33% - ${MENU_TILE_GRID_GAP}px)`,
  },
  borderRadius: 12,
  minHeight: '220px',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
});

export const TileFooter = Box.withConfig<{ isMenuItem: boolean }>(p => ({
  justifyContent: 'center',
  alignItems: 'center',
  height: p.isMenuItem ? '92px' : '54px',
  borderBottomRadius: Styles.borderRadius,
  _text: {
    variant: 'headerTwo',
    color: theme.token('text-default'),
    margin: '0',
    fontSize: 'lg',
    lineHeight: '20px',
    textAlign: 'center',
  },
}));

export const TileHeader = Header.withConfig(() => ({
  variant: 'headerTwo',
  fontSize: {
    base: 'lg',
    md: '2xl',
  },
  margin: 0,
  textTransform: 'none',
  numberOfLines: 2, // causes ellipsis
  _web: {
    lineHeight: 'normal',
  },
}));

export const TileDescription = Box.withConfig({
  flexShrink: 1,
  paddingX: {
    base: '$3',
    md: '$8',
  },
  paddingY: {
    base: 0,
    md: '$5',
  },
});

export const TileImageWrapper = Box.withConfig({
  minWidth: MENU_IMAGE_MOBILE_WIDTH,
});

export const TileImage = Picture.withConfig(() => ({
  width: {
    base: MENU_IMAGE_MOBILE_WIDTH,
    md: MENU_IMAGE_DESKTOP_WIDTH,
  },
  height: { base: MENU_IMAGE_MOBILE_WIDTH, md: MENU_IMAGE_DESKTOP_WIDTH },
  borderTopRadius: Styles.borderRadius,
  borderBottomRadius: {
    base: Styles.borderRadius,
    md: 0,
  },
}));

export const ItemPrice = Text.withConfig({
  fontWeight: 'bold',
  color: Styles.color.pricing,
});

export const StyledItemPrice = ItemPrice.withConfig({
  color: Styles.color.black,
  numberOfLines: 1,
  fontWeight: 'bold',
});

export const StyledPriceAndCaloriesListWrapper = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'center',
  space: '$2',
});

export const StyledListItemCalories = Text.withConfig({
  marginBottom: 0,
  marginTop: 0,
  color: Styles.color.black,
  numberOfLines: 1,
  textTransform: 'capitalize',
});

export const StyledMenuSectionTitle = Text.withConfig({
  fontSize: 'lg',
  lineHeight: 'sm',
  fontWeight: 'bold',
});
